import React, { useState, useEffect, useRef } from 'react';

export default function Tooltip({ definition }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <span ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        onClick={(e) => { e.preventDefault(); setOpen((o) => !o); }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '16px',
          height: '16px',
          borderRadius: '50%',
          background: open ? '#2563eb' : '#e5e7eb',
          color: open ? '#fff' : '#6b7280',
          border: 'none',
          cursor: 'pointer',
          fontSize: '10px',
          fontWeight: '700',
          lineHeight: 1,
          flexShrink: 0,
        }}
        aria-label="Show definition"
      >
        ?
      </button>
      {open && (
        <div
          style={{
            position: 'absolute',
            top: '22px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#fff',
            border: '1px solid #d1d5db',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
            padding: '10px 12px',
            maxWidth: '280px',
            minWidth: '180px',
            fontSize: '0.8rem',
            color: '#374151',
            lineHeight: '1.5',
            zIndex: 50,
          }}
        >
          {definition}
        </div>
      )}
    </span>
  );
}
